import { Controller } from '@hotwired/stimulus';
import { useDispatch } from 'stimulus-use';
import zenscroll from 'zenscroll';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

const useScrollTo = (controller, options = {}) => {
  Object.assign(controller, {
    scrollToTop(onDone) {
      zenscroll.setup(options.duration, this._getScrollToOffset());
      zenscroll.to(controller.element, options.duration, onDone);
    },

    _getScrollToOffset() {
      return parseInt(getComputedStyle(controller.element).getPropertyValue("scroll-margin-top"), 0);
    }

  });
};

let _default = /*#__PURE__*/function (_Controller) {
  _inherits(_default, _Controller);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      useScrollTo(this, {
        duration: 400
      });
      useDispatch(this, {
        eventPrefix: "expandable-section"
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.animateValue) this.element.classList.add(this.animateClass);
      this.openValue = !this.openValue;
      this.dispatch("toggle");
    }
  }, {
    key: "open",
    value: function open() {
      if (this.animateValue) this.element.classList.add(this.animateClass);
      this.openValue = true;
    }
  }, {
    key: "close",
    value: function close() {
      if (this.animateValue) this.element.classList.add(this.animateClass);
      this.openValue = false;
      this.toggleTarget.setAttribute("aria-expanded", false);
      this.contentTarget.setAttribute("aria-hidden", true);
      if (this.animateHeight) this.collapseContent();
    }
  }, {
    key: "openValueChanged",
    value: function openValueChanged() {
      this.toggleTarget.setAttribute("aria-expanded", this.openValue);
      this.contentTarget.setAttribute("aria-hidden", !this.openValue);
      if (this.animateValue) this.toggleContentHeight();
      if (this.openValue && this.collapseSiblingsValue) this.collapseSiblings();
    }
  }, {
    key: "collapseSiblings",
    value: function collapseSiblings() {
      this.siblingControllers.forEach(siblingController => {
        if (siblingController) siblingController.close();
      });
    }
  }, {
    key: "toggleContentHeight",
    value: function toggleContentHeight() {
      if (this.openValue) {
        this.expandContent();
      } else {
        this.collapseContent();
      }
    }
  }, {
    key: "expandContent",
    value: function expandContent() {
      requestAnimationFrame(() => {
        this.contentHeight = this.contentScrollHeight;
      });
    }
  }, {
    key: "onTransitionEnd",
    value: function onTransitionEnd(event) {
      if (event.target != this.contentTarget) return;
      if (this.shouldScroll) this.scrollToTop();
      if (this.openValue) this.resetContentHeight();
    }
  }, {
    key: "resetContentHeight",
    value: function resetContentHeight() {
      this.contentHeight = null;
    }
  }, {
    key: "collapseContent",
    value: function collapseContent() {
      const transition = this.contentTarget.style.transition;
      this.contentTarget.style.transition = "";
      requestAnimationFrame(() => {
        this.contentHeight = this.contentScrollHeight;
        this.contentTarget.style.transition = transition;
        requestAnimationFrame(() => {
          this.contentHeight = 0;
        });
      });
    }
  }, {
    key: "contentHeight",
    set: function (height) {
      if (Number.isInteger(height)) height = `${height}px`;
      this.contentTarget.style.height = height;
    }
  }, {
    key: "shouldScroll",
    get: function () {
      if (this.scrollToOnOpenValue && this.isOpen) return !this.isScrolledPast;
      if (this.scrollToOnCloseValue && this.isClosed) return this.isScrolledPast;
    }
  }, {
    key: "isOpen",
    get: function () {
      return this.openValue;
    }
  }, {
    key: "isClosed",
    get: function () {
      return !this.openValue;
    }
  }, {
    key: "contentScrollHeight",
    get: function () {
      return this.contentTarget.scrollHeight;
    }
  }, {
    key: "siblingControllers",
    get: function () {
      return [...this.siblings].map(sibling => {
        return this.application.getControllerForElementAndIdentifier(sibling, this.identifier);
      });
    }
  }, {
    key: "siblings",
    get: function () {
      let siblings = [];
      let sib = this.element.parentNode.firstChild;

      while (sib) {
        if (sib.nodeType === 1 && sib !== this.element) {
          siblings.push(sib);
        }

        sib = sib.nextSibling;
      }

      return siblings;
    }
  }, {
    key: "isScrolledPast",
    get: function () {
      const {
        top
      } = this.element.getBoundingClientRect();
      return top <= 0;
    }
  }]);

  return _default;
}(Controller);

_defineProperty(_default, "targets", ["toggle", "content"]);

_defineProperty(_default, "classes", ["animate"]);

_defineProperty(_default, "values", {
  animate: Boolean,
  open: Boolean,
  collapseSiblings: Boolean,
  stickyHeader: Boolean,
  scrollToOnClose: Boolean,
  scrollToOnOpen: Boolean
});

let _default$1 = /*#__PURE__*/function (_Controller) {
  _inherits(_default, _Controller);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      useScrollTo(this, {
        duration: 400
      });
      this.moreTarget.hidden = true;
      this.toggleTarget.hidden = false;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.toggleTarget.blur();
      this.moreTarget.hidden = !this.moreTarget.hidden;
      this.toggleTarget.setAttribute("aria-expanded", `${!this.moreTarget.hidden}`); // TODO: only scroll to top if scrolled past the top of the element

      if (this.isLess) this.scrollToTop();
    }
  }, {
    key: "isMore",
    get: function () {
      return !this.isLess;
    }
  }, {
    key: "isLess",
    get: function () {
      return this.moreTarget.hidden;
    }
  }]);

  return _default;
}(Controller);

_defineProperty(_default$1, "targets", ["more", "toggle"]);

let _default$2 = /*#__PURE__*/function (_Controller) {
  _inherits(_default, _Controller);

  var _super = _createSuper(_default);

  function _default() {
    _classCallCheck(this, _default);

    return _super.apply(this, arguments);
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      this.iconLibraryTarget.resolver = iconName => {
        return this.iconsValue[iconName];
      };
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      this.element.classList.add(this.startedClass);
    }
  }]);

  return _default;
}(Controller);

_defineProperty(_default$2, "targets", ["iconLibrary"]);

_defineProperty(_default$2, "values", {
  icons: Object
});

_defineProperty(_default$2, "classes", ["started"]);

const registerControllers = application => {
  application.register("architecture-of-territory--read-more-component", _default$1);
  application.register("architecture-of-territory--expandable-section-component", _default);
  application.register("architecture-of-territory--video-component", _default$2);
};

export { registerControllers };
//# sourceMappingURL=index.m.js.map
